const IST = 'Asia/Kolkata';

const DATETIME: Intl.DateTimeFormatOptions = {
  timeZone: IST,
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
};

const DATETIME_WITH_SECONDS: Intl.DateTimeFormatOptions = {
  ...DATETIME,
  second: '2-digit',
};

/** "Sat, 6 Sep 2026, 4:00 pm IST" */
export function formatIstDateTime(value: Date | string, withSeconds = false): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const formatted = new Intl.DateTimeFormat('en-IN', withSeconds ? DATETIME_WITH_SECONDS : DATETIME).format(
    date,
  );
  return `${formatted} IST`;
}
